import styled from '@emotion/styled';

import { Card, HintText, Panel, SectionLabel } from '../../../../../shared/styles/components/primitives.styles';
import { theme } from '../../../../../shared/styles/core/theme';
import { tokens } from '../../../../../shared/styles/core/tokens';

export const ComparisonGrid = styled.div`
   display: flex;
   align-items: stretch;
   gap: ${tokens.space.md};
`;

export const SpreadRow = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   margin-bottom: ${tokens.space.md};
`;

export const LinkGroup = styled.div`
   display: flex;
   gap: ${tokens.space.md};
`;

export const CheckboxRow = styled.div`
   display: flex;
   align-items: center;
   gap: ${tokens.space.sm};
`;

export const SelectableValueRow = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: flex-start;
   gap: ${tokens.space.md};
 `;

export const IntroHint = styled(HintText)`
   display: block;
   margin-bottom: ${tokens.space.md};
`;

export const GroupCard = styled(Card)`
   margin-bottom: ${tokens.space.md};
`;

export const RelativePanel = styled(Panel)`
   position: relative;
`;

export const PanelCornerAction = styled.div`
   position: absolute;
   top: ${tokens.space.sm};
   right: ${tokens.space.sm};
`;

export const ArrowSeparator = styled.span`
   display: flex;
   align-items: center;
   font-size: ${tokens.font.size.xxl};
   color: ${theme.colors.text.tertiary};
`;

export const NewSectionLabel = styled(SectionLabel)`
   color: ${theme.colors.state.success};
`;
